import { render } from "./BookingKanban.vue?vue&type=template&id=95edd3ea&scoped=true"
import script from "./BookingKanban.vue?vue&type=script&lang=js"
export * from "./BookingKanban.vue?vue&type=script&lang=js"

import "./BookingKanban.vue?vue&type=style&index=0&id=95edd3ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95edd3ea"]])

export default __exports__